<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Estimated Value:{{ setValue }}</label>
      <input class="form-control" v-model="estimated_value" placeholder="Enter value" />
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary text-light btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button"  :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-success text-light btn-sm ml-1" @click="save">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Save
      </button>
    </div>
  </form>
</template>

<script>
  import axios from "axios";

  export default {
    props: ["action", "formData", "pageNumber"],
    data: function () {
      return {
        estimated_value: "",
        isMiniLoading : false,
        colorFilter: "",
        temp: true,
      };
    },
    created: function () {
      this.colorFilter = "";
    },
    computed: {
      setValue() {
        this.estimated_value = this.formData.estimated_value;
        this.colorFilter = this.formData.color;
      },
    },
    methods: {
      save() {
        this.isMiniLoading = true;
        let demo_id = this.formData.user;
        let page_no = this.formData.pageNumber;
        let self = this;
        let estimated_value = self.estimated_value;
        if (estimated_value != undefined && estimated_value > 0.0) {
           const permission = {
      headers: {
        'X-Permission': 'lead_set_estimated_date' 
      }
    };
          axios
            .post("/admin/users/save-estimated-value", {
              value: estimated_value,
              id: demo_id,
            },permission)
            .then(() => {
              this.isMiniLoading = false;
              this.$toast.success("Estimated Value has been set successfully");
              window.$("#modal").modal("hide");
              this.$store.dispatch("users/getAllDemoRequests", [
                page_no,
                "",
                self.formData.status,
                "",
                "",
                "",
                "",
                "",
                "",
                self.colorFilter ? self.colorFilter : "",
                self.formData.followup_filter,
                'all',
                'all',
              ]);
            })
            .catch((error) => {
              this.isMiniLoading = false;
              this.$toast.error("OPPS! Something Went Wrong");
            });
        } else {
          this.isMiniLoading = false;
          this.$toast.error("Enter value which is greater than zero");
        }
      },
    },
  };
</script>